import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" transform="rotate(180)" {...props}><path d="M15.84 6.92v2h-12l5.5 5.5-1.42 1.42L0 7.92 7.92 0l1.42 1.42-5.5 5.5h12z" fill="currentColor" id="$" /></svg>);